export default {"src":"/_next/static/media/GS-Facebook-White.71daede6.svg","height":18,"width":10,"blurWidth":0,"blurHeight":0};